import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    wrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
    },
    myDashboardWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
    },
    statusWrapper: {
        width: "150px",
        display: "flex",
        gap: theme.spacing(2),
        alignItems: "center",
        "&::first-letter": {
            textTransform: "capitalize",
        },
    },
    statusBadge: {
        marginTop: `${theme.spacing(0.375)} !important`,
    },
}));
